import * as React from "react";
import { Component } from "react";
import { Device, Dcdataextractionattemptlog } from "@inductosense/typescript-fetch";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link } from "@mui/material";
import { CheckCircleOutline, ErrorOutlined } from "@mui/icons-material";
import UiSettings from "../Model/UiSettings";
import Services from "Services/Platform/Services";
import ModalPanel from "../Panels/ModalPanel";

interface DeviceDataExtractionLogsPanelProps {
    device: Device;
    uiSettings: UiSettings;
}

interface DeviceDataExtractionLogsPanelState {
    logs?: Dcdataextractionattemptlog[];
    showingLogTextFor?: Dcdataextractionattemptlog;
}

export default class DeviceDataExtractionLogsPanel extends Component<DeviceDataExtractionLogsPanelProps, DeviceDataExtractionLogsPanelState> {
    constructor(props: DeviceDataExtractionLogsPanelProps) {
        super(props);

        this.state = {};
    }

    async componentDidMount() {
        const allLogs = await Services.DcDeployments.getDcDataExtractionAttemptLogs();
        const filteredLogs = allLogs.filter(log => log.deviceId === this.props.device.id);
        this.setState({ logs: filteredLogs });
    }

    render() {
        const { logs, showingLogTextFor } = this.state;
        if (logs === undefined) return <p>Loading...</p>;

        return (
            <div style={{ overflowY: "auto", width: "100%", height: "80vh" }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Readings Extracted</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map((log, index) =>
                                <TableRow key={index}>
                                    <TableCell style={{ width: 200 }} title={log.dateTime.toString()}>
                                        {log.dateTime.toDateString()} {log.dateTime.toLocaleTimeString()}
                                    </TableCell>
                                    <TableCell>
                                        {
                                            log.allReadingsExtracted ?
                                                <CheckCircleOutline style={{ verticalAlign: "middle" }} />
                                                : <ErrorOutlined style={{ verticalAlign: "middle" }} />
                                        } &nbsp;
                                        {log.numberOfReadingsExtracted}
                                    </TableCell>
                                    <TableCell>
                                        {Services.userHasPolicy("ViewLogTextUi") ? <Link href="#" onClick={() => this.setState({ showingLogTextFor: log })}>Show logs</Link> : null}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {showingLogTextFor !== undefined ?
                    <ModalPanel
                        content={
                            <div style={{ overflowY: "auto", whiteSpace: "pre-line", width: "100%", height: "80vh" }}>
                                {showingLogTextFor.logText}
                            </div>
                        }
                        shouldBeShown={true}
                        title={`Log text ${showingLogTextFor.dateTime.toDateString()} ${showingLogTextFor.dateTime.toLocaleTimeString()}`}
                        onClose={() => this.setState({ showingLogTextFor: undefined })}
                    />
                    : null
                }
            </div>
        );
    }
}
